export const MAX_DARK_READ_MULTIPLIER = 10;
export const MAX_DARK_READ_MULTIPLIER_MOBILE = 5;
